export { default as fontAwesomeCategories } from './categories';
export { default as fontAwesomeIcons } from './icons';
